export const Logo = ({ size = 26 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Hookpipe"
    className="shrink-0"
    stroke="currentColor"
    strokeWidth={14}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M24 18 V86" />
    <path d="M24 46 A18 18 0 0 1 60 46 V102" />
    <path d="M60 52 H76 A18 18 0 0 1 76 88 H60" />
  </svg>
);

export const Brand = () => (
  <div className="flex items-center gap-3 text-primary">
    <Logo />
    <span className="text-brand font-bold tracking-title">Hookpipe</span>
  </div>
);
